interface AccountMenuProps {
  name: string;
  email: string;
  dark: boolean;
  onToggleDark: () => void;
  onSignOut: () => void;
  onClose: () => void;
}

export function AccountMenu({ name, email, dark, onToggleDark, onSignOut, onClose }: AccountMenuProps) {
  return (
    <>
      <div onClick={onClose} className="absolute inset-0 z-10" />
      <div className="absolute right-4 top-16 z-20 w-[232px] rounded-card bg-card p-2 shadow-menu">
        <div className="px-3 pb-2.5 pt-3">
          <div className="text-[15px] font-bold text-ink">{name}</div>
          <div className="mt-0.5 text-xs font-semibold text-faint">{email}</div>
        </div>
        <div className="mx-2 mb-1 h-px" style={{ background: 'var(--menu-divider)' }} />
        <div
          onClick={onToggleDark}
          className="flex cursor-pointer items-center justify-between rounded-xl px-3 py-[11px] hover:bg-hov"
        >
          <span className="text-sm font-bold text-ink">Dark mode</span>
          <div
            className="relative h-[25px] w-[42px] rounded-[13px] transition-colors duration-200"
            style={{ background: dark ? 'var(--ok)' : 'var(--muted)' }}
          >
            <div
              className="absolute top-[2.5px] h-5 w-5 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,.3)] transition-[left] duration-200"
              style={{ left: dark ? 19.5 : 2.5 }}
            />
          </div>
        </div>
        <div
          onClick={onSignOut}
          className="flex cursor-pointer items-center rounded-xl px-3 py-[11px] text-sm font-bold text-sub hover:bg-hov"
        >
          Sign out
        </div>
      </div>
    </>
  );
}
